var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// - Import react components
/*tslint:disable*/
/*eslint:disable*/
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { List as ImuList } from 'immutable';
import { Card, CardHeader, CardContent } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import { grey } from '@material-ui/core/colors';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';
import SvgRemoveImage from '@material-ui/icons/RemoveCircle';
import SvgCamera from '@material-ui/icons/PhotoCamera';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { withStyles } from '@material-ui/core/styles';
import { Manager, Target, Popper } from 'react-popper';
import Grow from '@material-ui/core/Grow';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import classNames from 'classnames';
// - Import app components
import ImageGallery from 'components/imageGallery';
import Img3 from 'components/img3';
import OrderImgs from './REorderImages';
import UserAvatarComponent from 'components/userAvatar';
import Input from '@material-ui/core/Input';
import QRcode from 'components/QRcode';
// - Import API
import * as PostAPI from 'api/PostAPI';
import * as postActions from 'store/actions/postActions';
import { Inventory } from 'core/domain/Inventory';
import Grid from '@material-ui/core/Grid/Grid';
import SizeInput from 'components/SizeInput';
import './postcomp.css';
import './postcomp1.css';
var styles = function (theme) {
    var _a;
    return ({
        fullPageXs: (_a = {},
            _a[theme.breakpoints.down('xs')] = {
                width: '100%',
                height: '100%',
                margin: 0,
                overflowY: 'auto'
            },
            _a),
        backdrop: {
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: '-1',
            position: 'fixed',
            willChange: 'opacity',
            backgroundColor: 'rgba(251, 249, 249, 0.5)',
            WebkitTapHighlightColor: 'transparent'
        },
        content: {
            padding: 0,
            paddingTop: 0
        },
        dialogRoot: {
            paddingTop: 0
        },
        popperOpen: {
            zIndex: 10
        },
        popperClose: {
            pointerEvents: 'none',
            zIndex: 0
        },
        author: {
            paddingRight: 70
        },
        inputField: {}
    });
};
// - Create PostWrite component class
var PostWriteComponent = /** @class */ (function (_super) {
    __extends(PostWriteComponent, _super);
    /**
     * Component constructor
     * @param  {object} props is an object properties of component
     */
    function PostWriteComponent(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Toggle comments of the post to disable/enable
         *
         *
         * @memberof PostWrite
         */
        _this.handleToggleComments = function () {
            _this.setState({
                disableComments: !_this.state.disableComments,
                disabledPost: false
            });
        };
        /**
         * Toggle sharing of the post to disable/enable
         *
         *
         * @memberof PostWrite
         */
        _this.handleToggleSharing = function () {
            _this.setState({
                disableSharing: !_this.state.disableSharing,
                disabledPost: false
            });
        };
        /**
         * Romove the image of post
         *
         *
         * @memberof PostWrite
         */
        _this.handleRemoveImage = function () {
            _this.setState(function (prevState) { return ({
                image: '',
                imageFullPathArr: [],
                imageFullPath: '',
                disabledPost: _this.state.postText.trim() === ''
            }); });
        };
        /**
         * Handle send post to the server
         * @param  {event} evt passed by clicking on the post button
         */
        _this.handlePost = function () {
            var _a = _this.state, image = _a.image, imageFullPath = _a.imageFullPath, disableComments = _a.disableComments, disableSharing = _a.disableSharing, postText = _a.postText, imageArr = _a.imageArr, imageFullPathArr = _a.imageFullPathArr, Description = _a.Description;
            var _b = _this.props, id = _b.id, ownerAvatar = _b.ownerAvatar, ownerDisplayName = _b.ownerDisplayName, edit = _b.edit, onRequestClose = _b.onRequestClose, post = _b.post, update = _b.update, postModel = _b.postModel;
            if (_this.state.price == '0') {
                alert('please set price');
                return;
            }
            if (image === '' && postText.trim() === '') {
                alert('no image');
                return;
            }
            var tags = PostAPI.getContentTags(postText);
            var myinventory = new Inventory;
            myinventory.Small = _this.state.Small;
            myinventory.Medium = _this.state.Medium;
            myinventory.Large = _this.state.Large;
            myinventory.XL = _this.state.XL;
            myinventory.XXL = _this.state.XXL;
            var sizeObj = {
                Small: _this.state.Small,
                Medium: _this.state.Medium,
                Large: _this.state.Large,
                XL: _this.state.XL,
                XXL: _this.state.XXL
            };
            // this.setState({
            //   Inventory: myinventory
            // })
            // In edit status we should fire update if not we should fire post function
            if (!edit) {
                if (image !== '') {
                    var originalPrice = parseInt(_this.state.price);
                    originalPrice += 8;
                    post({
                        body: postText,
                        tags: tags,
                        ShippingPrice: 8.00,
                        image: image,
                        imageArr: imageArr,
                        imageFullPathArr: imageFullPathArr,
                        imageFullPath: imageFullPath,
                        ownerAvatar: ownerAvatar,
                        ownerDisplayName: ownerDisplayName,
                        disableComments: disableComments,
                        disableSharing: disableSharing,
                        postTypeId: 1,
                        score: 0,
                        viewCount: 0,
                        color: _this.state.color,
                        fabric: _this.state.fabric,
                        Inventory: _this.state.InvMap,
                        price: originalPrice,
                        DesignName: _this.state.DesignName,
                        ownerMerchantId: _this.props.ownerMerchantId,
                        ownerUserName: _this.props.ownerUserName,
                        available: false,
                        Description: _this.state.Description,
                        Type: _this.state.Type,
                        isOwnerVerified: _this.props.isOwnerVerified || false,
                    }, function (postid) {
                        _this.setState({ postId: postid });
                        alert('Post Successful');
                        _this.handleCloseMenu();
                    });
                    // this.setState({showQr:true })
                }
                else {
                    post({
                        body: postText,
                        image: image,
                        imageArr: imageArr,
                        imageFullPathArr: imageFullPathArr,
                        imageFullPath: imageFullPath,
                        tags: tags,
                        Description: _this.state.Description,
                        ownerAvatar: ownerAvatar,
                        ownerDisplayName: ownerDisplayName,
                        disableComments: disableComments,
                        disableSharing: disableSharing,
                        postTypeId: 0,
                        score: 0,
                        viewCount: 0,
                    }, function (postid) {
                        _this.setState({ postId: postid });
                    });
                }
            }
            else { // In edit status we pass post to update functions
                var updatedPost = postModel.set('body', postText)
                    .set('tags', ImuList(tags))
                    .set('image', image)
                    .set('imageFullPath', imageFullPath)
                    .set('disableComments', disableComments)
                    .set('disableSharing', disableSharing)
                    .set('Description', Description);
                // .set('Price', )
                update(updatedPost, onRequestClose); // TODO ADD EDIT TO PROPERITES
            }
        };
        /**
         * Set post image url
         */
        _this.onRequestSetImage = function (url, fullPath, imageArr) {
            _this.setState(function (prevState) { return ({
                image: url,
                imageArr: imageArr ? imageArr : [],
                imageFullPathArr: prevState.imageFullPathArr.concat([fullPath]),
                imageFullPath: fullPath,
                disabledPost: false
            }); });
            console.warn(_this.state.image);
        };
        /**
         * When the post text changed
         * @param  {event} evt is an event passed by change post text callback funciton
         * @param  {string} data is the post content which user writes
         */
        _this.handleOnChange = function (event) {
            var data = event.target.value;
            _this.setState({ postText: data });
            if (data.length === 0 || data.trim() === '' || (_this.props.edit && data.trim() === _this.props.text)) {
                _this.setState({
                    postText: data,
                    disabledPost: true
                });
            }
            else {
                _this.setState({
                    postText: data,
                    disabledPost: false
                });
            }
        };
        /**
         * Close image gallery
         */
        _this.handleCloseGallery = function () {
            _this.setState({
                galleryOpen: false
            });
        };
        /**
         * Open image gallery
         */
        _this.handleOpenGallery = function () {
            _this.setState({
                galleryOpen: true
            });
        };
        /**
         * Handle open more menu
         */
        _this.handleOpenMenu = function () {
            _this.setState({
                menuOpen: true
            });
        };
        _this.handleCloseMenu = function () {
            _this.setState({
                menuOpen: false
            });
        };
        var postModel = props.postModel;
        // Default state
        _this.state = {
            /**
             * Post text
             */
            postText: _this.props.edit && postModel ? postModel.get('body', '') : '',
            /**
             * The URL image of the post
             */
            image: _this.props.edit && postModel ? postModel.get('image', '') : '',
            /**
             * The path identifier of image on the server
             */
            imageFullPath: _this.props.edit && postModel ? postModel.get('imageFullPath', '') : '',
            imageFullPathArr: _this.props.edit && postModel ? postModel.get('imageFullPathArr', '') : '',
            imageArr: _this.props.edit && postModel ? postModel.get('imageArr', '') : '',
            /**
             * If it's true gallery will be open
             */
            galleryOpen: false,
            /**
             * Whether menu is open
             */
            menuOpen: false,
            /**
             * If it's true post button will be disabled
             */
            disabledPost: true,
            /**
             * If it's true comment will be disabled on post
             */
            disableComments: _this.props.edit && postModel ? postModel.get('disableComments') : false,
            /**
             * If it's true share will be disabled on post
             */
            disableSharing: _this.props.edit && postModel ? postModel.get('disableSharing') : false,
            fabric: 'not cotton',
            Inventory: {},
            DesignName: '',
            Small: 0,
            Medium: 0,
            Large: 0,
            XL: 0,
            XXL: 0,
            Type: '',
            color: '',
            InvMap: {},
            price: _this.props.edit && postModel ? postModel.get('price', '') || 'yer' : 'yo',
            Description: '',
            showQr: false,
            postId: _this.props.edit && postModel ? postModel.get('id', '') : '',
            available: postModel ? postModel.get('available') || false : false,
            ownerMerchantId: postModel ? postModel.get('ownerMerchantid') || '' : '',
            fieldRequired: true
        };
        // Binding functions to `this`
        _this.handleOnChange = _this.handleOnChange.bind(_this);
        _this.handleCloseGallery = _this.handleCloseGallery.bind(_this);
        _this.handleOpenGallery = _this.handleOpenGallery.bind(_this);
        _this.onRequestSetImage = _this.onRequestSetImage.bind(_this);
        _this.handlePost = _this.handlePost.bind(_this);
        _this.handleRemoveImage = _this.handleRemoveImage.bind(_this);
        _this.handleToggleComments = _this.handleToggleComments.bind(_this);
        _this.handleToggleSharing = _this.handleToggleSharing.bind(_this);
        _this.priceSet = _this.priceSet.bind(_this);
        _this.nameSet = _this.nameSet.bind(_this);
        _this.detailSet = _this.detailSet.bind(_this);
        _this.typeset = _this.typeset.bind(_this);
        _this.sizeSet = _this.sizeSet.bind(_this);
        _this.OrderImages = _this.OrderImages.bind(_this);
        _this.setInventory = _this.setInventory.bind(_this);
        return _this;
    }
    /**
     * Handle close more menu
     */
    PostWriteComponent.prototype.componentDidMount = function () {
        if (this.props.edit) {
            this.setState({ fieldRequired: false });
        }
    };
    PostWriteComponent.prototype.componentWillUnmount = function () {
        this.setState({
            showQr: false
        });
    };
    PostWriteComponent.prototype.componentWillReceiveProps = function (nextProps) {
        if (!nextProps.open) {
            var postModel = this.props.postModel;
            this.setState({
                /**
                 * Post text
                 */
                postText: this.props.edit && postModel ? postModel.get('body', '') : '',
                /**
                 * The URL image of the post
                 */
                image: this.props.edit && postModel ? postModel.get('image', '') : '',
                /**
                 * The path identifier of image on the server
                 */
                imageFullPath: this.props.edit && postModel ? postModel.get('imageFullPath', '') : '',
                /**
                 * If it's true gallery will be open
                 */
                galleryOpen: false,
                /**
                 * Whether menu is open
                 */
                menuOpen: false,
                /**
                 * If it's true post button will be disabled
                 */
                disabledPost: true,
                /**
                 * If it's true comment will be disabled on post
                 */
                disableComments: this.props.edit && postModel ? postModel.get('disableComments') : false,
                /**
                 * If it's true share will be disabled on post
                 */
                disableSharing: this.props.edit && postModel ? postModel.get('disableSharing') : false,
                postId: this.props.edit && postModel ? postModel.get('id') : ''
            });
        }
    };
    PostWriteComponent.prototype.handleSubmit = function () {
        console.warn('handled');
    };
    PostWriteComponent.prototype.priceSet = function (e) {
        this.setState({
            price: e.target.value
        });
    };
    PostWriteComponent.prototype.typeset = function (e) {
        this.setState({
            Type: e.target.value
        });
    };
    PostWriteComponent.prototype.GenderSet = function (e) {
        // this.setState({
        //   Gender: e.target.value
        // })
        // alert(this.state.Type)
    };
    PostWriteComponent.prototype.nameSet = function (e) {
        this.setState({
            DesignName: e.target.value
        });
    };
    PostWriteComponent.prototype.detailSet = function (e) {
        this.setState({
            Description: e.target.value
        });
    };
    PostWriteComponent.prototype.sizeSet = function (e) {
        var _a, _b;
        var name = e.target.name;
        this.setState((_a = {},
            _a[name] = e.target.value,
            _a.Inventory = (_b = {}, _b[name] = e.target.value, _b),
            _a));
        console.log('INVV', this.state.Inventory);
    };
    PostWriteComponent.prototype.setInventory = function (InventorySizes) {
        this.setState({
            InvMap: InventorySizes
        });
    };
    PostWriteComponent.prototype.OrderImages = function (NewimageArr) {
        this.setState({ imageArr: NewimageArr });
    };
    /**
     * Reneder component DOM
     * @return {react element} return the DOM which rendered by component
     */
    PostWriteComponent.prototype.render = function () {
        var _this = this;
        var _a, _b;
        var _c = this.props, classes = _c.classes, translate = _c.translate;
        var menuOpen = this.state.menuOpen;
        var rightIconMenu = (React.createElement(Manager, null,
            React.createElement(Target, null,
                React.createElement(Tooltip, { id: 'tooltip-icon', title: translate('post.moreTooltip'), placement: 'bottom-start' },
                    React.createElement(IconButton, { onClick: this.handleOpenMenu },
                        React.createElement(MoreVertIcon, null)))),
            React.createElement(Popper, { placement: 'bottom-start', eventsEnabled: menuOpen, className: classNames((_a = {}, _a[classes.popperClose] = !menuOpen, _a), (_b = {}, _b[classes.popperOpen] = menuOpen, _b)) },
                React.createElement(ClickAwayListener, { onClickAway: this.handleCloseMenu },
                    React.createElement(Grow, { in: menuOpen },
                        React.createElement(Paper, null,
                            React.createElement(MenuList, { role: 'menu' },
                                React.createElement(MenuItem, { onClick: this.handleToggleComments, style: { fontSize: '14px' } },
                                    !this.state.disableComments ? 'Disable comments' : 'Enable comments',
                                    " "),
                                React.createElement(MenuItem, { onClick: this.handleToggleSharing, style: { fontSize: '14px' } }, !this.state.disableSharing ? 'Disable sharing' : 'Enable sharing'))))))));
        var postAvatar = React.createElement(UserAvatarComponent, { fullName: this.props.ownerDisplayName, fileName: this.props.ownerAvatar, size: 36 });
        var author = (React.createElement("div", { className: classes.author },
            React.createElement("span", { style: {
                    fontSize: '14px',
                    paddingRight: '10px',
                    fontWeight: 400,
                    color: 'rgba(0,0,0,0.87)',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    lineHeight: '25px'
                } }, this.props.ownerDisplayName),
            React.createElement("span", { style: {
                    fontWeight: 400,
                    fontSize: '10px'
                } },
                " | ",
                translate('post.public'))));
        var obj = {
            UserName: this.props.ownerDisplayName,
            userId: this.props.ownerUid,
            PostName: this.props.DesignName,
            PostId: this.state.postId,
            Price: this.state.price,
            OwnerDisplayName: this.props.ownerDisplayName,
            URL: this.state.image
        };
        var postInfo = JSON.stringify(obj);
        /**
         * Provide post image
         */
        var loadImage = (this.state.imageArr && this.state.image !== '')
            ? (React.createElement("div", { style: { maxWidth: '650px', height: '900px' } },
                React.createElement("div", { style: { position: 'relative', overflowY: 'hidden', overflowX: 'auto' } },
                    React.createElement("ul", { style: { position: 'relative', whiteSpace: 'nowrap', padding: '0 0 0 16px', margin: '8px 0 0 0', paddingRight: '16px', verticalAlign: 'bottom', flexShrink: 0, listStyleType: 'none' } },
                        React.createElement("div", { style: { display: 'flex', position: 'relative' } },
                            React.createElement("span", { onClick: this.handleRemoveImage, style: {
                                    position: 'absolute', width: '28px', backgroundColor: 'rgba(255, 255, 255, 0.22)',
                                    height: '28px', right: 12, top: 4, cursor: 'pointer', borderRadius: '50%',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center'
                                } },
                                React.createElement(SvgRemoveImage, { style: { color: 'rgba(0, 0, 0, 0.53)' } })),
                            React.createElement("div", { style: { display: 'inline-block', width: '100%', marginRight: '8px', transition: 'transform .25s' } },
                                React.createElement("li", { style: { width: '100%', margin: 0, verticalAlign: 'bottom', position: 'static' } },
                                    React.createElement(Img3, { model: this.state.imageArr ? this.state.imageArr : this.state.image, height: '350px' })))))),
                React.createElement(OrderImgs, { reorder: this.OrderImages, ImageArr: this.state.imageArr }),
                React.createElement("div", { style: { textAlign: 'center', margin: 'auto', marginTop: '10px' } },
                    React.createElement("form", { className: 'form', onSubmit: function (e) { e.preventDefault(); _this.handlePost(); } },
                        React.createElement(Input, { className: 'exampleinput', required: this.state.fieldRequired, type: 'text', placeholder: 'Design Name', onChange: this.nameSet }),
                        React.createElement("br", null),
                        "$",
                        React.createElement(Input, { className: 'exampleinput', required: this.state.fieldRequired, type: 'number', placeholder: 'Price', onChange: this.priceSet }),
                        React.createElement("br", null),
                        React.createElement("br", null),
                        React.createElement(Input, { name: 'color', className: 'exampleinput', required: this.state.fieldRequired, type: 'text', placeholder: 'Main Color', onChange: this.sizeSet }),
                        React.createElement("br", null),
                        React.createElement("br", null),
                        React.createElement("select", { onChange: this.typeset, style: { width: '90%' }, className: 'select-box' },
                            React.createElement("option", { selected: true, disabled: true }, "Category: "),
                            React.createElement("option", { value: 'Sweaters' }, "Sweaters"),
                            React.createElement("option", { value: 'Hats' }, "Hats"),
                            React.createElement("option", { value: 'Dresses' }, "Dresses"),
                            React.createElement("option", { value: 'Shirts' }, "T-Shirts"),
                            React.createElement("option", { value: 'Masks' }, "Masks"),
                            React.createElement("option", { value: 'Sneakers' }, "Sneakers"),
                            React.createElement("option", { value: 'Skincare' }, "Skincare"),
                            React.createElement("option", { value: 'Pants' }, "Pants"),
                            React.createElement("option", { value: 'Swimwear' }, "Swimwear"),
                            React.createElement("option", { value: 'Backpack' }, "Backpack")),
                        React.createElement("br", null),
                        React.createElement("br", null),
                        React.createElement("div", { style: { textAlign: 'left' } }, " Inventory: "),
                        this.state.Type === 'Hats'
                            || this.state.Type === 'Masks'
                            || this.state.Type === 'Skincare'
                            || this.state.Type === 'Backpack' ?
                            // <br/>
                            React.createElement("div", null,
                                React.createElement(Input, { name: 'Small', className: 'exampleinput', required: this.state.fieldRequired, type: 'text', placeholder: 'Quantity', onChange: this.sizeSet }),
                                React.createElement("br", null))
                            :
                                // <br />
                                React.createElement(SizeInput, { updateState: function (Inv) { _this.setInventory(Inv); }, Type: this.state.Type }),
                        React.createElement("br", null),
                        React.createElement("div", { style: { textAlign: 'center' } },
                            React.createElement("div", { style: { margin: 'auto' } },
                                React.createElement("select", { onChange: this.GenderSet, style: { width: '90%' }, className: 'select-box' },
                                    React.createElement("option", { selected: true, disabled: true }, "Made For"),
                                    React.createElement("option", { value: 'Mens' }, "Mens"),
                                    React.createElement("option", { value: 'Unisex' }, "Unisex"),
                                    React.createElement("option", { value: 'Womens' }, "Womens")))),
                        React.createElement("textarea", { className: 'Tarea', style: {
                                borderRadius: '5px',
                                height: '100px',
                                width: '30em',
                                maxWidth: '90%',
                                marginTop: '3%',
                                borderWidth: '1px',
                                borderStyle: 'solid',
                                borderColor: '#33383b'
                            }, onChange: this.detailSet, placeholder: 'Details' }),
                        React.createElement("br", null),
                        React.createElement("button", { style: { width: '15em', margin: 'auto' }, className: 'examplebutton' }, this.props.edit ? translate('post.updateButton') : translate('post.postButton')))),
                React.createElement(Button, { color: 'primary', disableFocusRipple: true, disableRipple: true, style: { color: grey[800] }, onClick: function () { _this.setState({ showQr: !_this.state.showQr }); } }, "Show QrCode"))) : '';
        var styles = {
            dialog: {
                width: '',
                maxWidth: '530px',
                borderRadius: '4px'
            }
        };
        return (React.createElement("div", { style: this.props.style },
            this.props.children,
            React.createElement(Dialog, { BackdropProps: { className: classes.backdrop }, PaperProps: { className: classes.fullPageXs }, key: this.props.id || 0, open: this.props.open, onClose: this.props.onRequestClose },
                React.createElement(DialogContent, { className: classes.content, style: { paddingTop: 0 } },
                    React.createElement(Card, { elevation: 0 },
                        React.createElement(CardHeader, { title: author, avatar: postAvatar, action: rightIconMenu }),
                        React.createElement(CardContent, null, !this.state.showQr ?
                            React.createElement(Grid, { item: true, xs: 12 },
                                React.createElement("div", { style: { display: 'flex', flexDirection: 'column', flexGrow: 1, overflow: 'hidden' } },
                                    React.createElement("div", { style: { position: 'relative', flexDirection: 'column', display: 'flex', flexGrow: 1, overflow: 'hidden', overflowY: 'auto', maxHeight: '300px' } }, loadImage),
                                    React.createElement("div", { style: { flexShrink: 0, boxFlex: 0, flexGrow: 0, maxHeight: '48px', width: '100%' } },
                                        React.createElement("div", { style: { flexDirection: 'row', display: 'flex' } },
                                            React.createElement("div", { onClick: this.handleOpenGallery, style: { outline: 'none', width: '48px', zIndex: 0, overflow: 'hidden', position: 'relative', textAlign: 'center', transition: 'background .3s', border: 0, borderRadius: '50%', display: 'inlineBlock', height: '48px' } },
                                                React.createElement("span", { style: { top: '15px', display: 'block', position: 'relative', cursor: 'pointer' } },
                                                    React.createElement(SvgCamera, { style: { color: 'grey' } })))))))
                            : React.createElement("div", null,
                                " ",
                                React.createElement(QRcode, { userPage: postInfo, open: this.state.showQr }),
                                " ")))),
                React.createElement(DialogActions, null,
                    React.createElement(Button, { color: 'primary', disableFocusRipple: true, disableRipple: true, onClick: function () { _this.setState({ showQr: false }); _this.props.onRequestClose(); }, style: { color: grey[800] } }, translate('post.cancelButton')))),
            React.createElement(Dialog, { PaperProps: { className: classes.fullPageXs }, open: this.state.galleryOpen, onClose: this.handleCloseGallery },
                React.createElement(DialogContent, null,
                    React.createElement(ImageGallery, { set: this.onRequestSetImage, close: this.handleCloseGallery })),
                React.createElement(DialogActions, null,
                    React.createElement(Button, { color: 'primary', disableFocusRipple: true, disableRipple: true, onClick: this.handleCloseGallery, style: { color: grey[800] } }, translate('post.cancelButton'))))));
    };
    return PostWriteComponent;
}(Component));
export { PostWriteComponent };
/**
 * Map dispatch to props
 * @param  {func} dispatch is the function to dispatch action to reducers
 * @param  {object} ownProps is the props belong to component
 * @return {object}          props of component
 */
var mapDispatchToProps = function (dispatch, ownProps) {
    return {
        post: function (post, callBack) { return dispatch(postActions.dbAddImagePost(post, callBack)); },
        post1: function (post, callBack) { return dispatch(postActions.dbAddGLTFPost(post, callBack)); },
        update: function (post, callBack) { return dispatch(postActions.dbUpdatePost(post, callBack)); }
    };
};
/**
 * Map state to props
 * @param  {object} state is the obeject from redux store
 * @param  {object} ownProps is the props belong to component
 * @return {object}          props of component
 */
var mapStateToProps = function (state, ownProps) {
    var uid = state.getIn(['authorize', 'uid']);
    var user = state.getIn(['user', 'info', uid], {});
    return {
        translate: getTranslate(state.get('locale')),
        postImageState: state.getIn(['imageGallery', 'status']),
        ownerAvatar: user.avatar || '',
        isOwnerVerified: user.HTVerified || false,
        ownerMerchantId: user.merchant_Id,
        ownerUserName: user.userName,
        ownerDisplayName: user.fullName || '',
        ownerUid: uid
    };
};
// - Connect component to redux store
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PostWriteComponent));



//////////////////
// WEBPACK FOOTER
// ./src/components/postWrite/PostWriteComponent.tsx
// module id = 1264
// module chunks = 0 1 2 3 4 5 6 7